<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app>
      <div class="pl-3 pr-3 pt-3 text-center">
        <router-link :to="{ name: 'CompaniesList' }">
          <img
            id="rehab-logo"
            alt="rehab.com logo"
            src="https://www.rehab.com/assets/images/v2/us/homepage/logo_home.svg"
          />
        </router-link>
      </div>

      <v-list>
        <!-- Providers -->
        <v-list-item link :to="{ name: 'CompaniesList' }">
          <v-list-item-action>
            <v-icon>mdi-office-building</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Providers</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- COMPANIES -->
        <v-list-item link :to="{ name: 'UserList' }">
          <v-list-item-action>
            <v-icon>mdi-account-group</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Users</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- REPORTING -->
        <v-list-item link :to="{ name: 'Reporting' }">
          <v-list-item-action>
            <v-icon>mdi-file-chart</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Reporting</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
          prepend-icon="mdi-cash-multiple"
          :value="
            $route.fullPath.includes('financial-reporting') ? true : false
          "
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Financial Reporting</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item link :to="{ name: 'FinancialDashboard' }">
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item>
          <v-list-item link :to="{ name: 'BillingReport' }">
            <v-list-item-title>Billing</v-list-item-title>
          </v-list-item>
          <v-list-item link :to="{ name: 'ActivityReport' }">
            <v-list-item-title>Activity</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- REPORTING -->
        <v-list-item link :to="{ name: 'Downgrades' }">
          <v-list-item-action>
            <v-icon>mdi-transfer-down</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Downgrades</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>{{ $title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu right bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item :to="{ name: 'password-reset' }">
            <v-list-item-title
              ><v-icon>mdi-lock-reset</v-icon> Reset Password</v-list-item-title
            >
          </v-list-item>
          <v-list-item to="/">
            <v-list-item-title
              ><v-icon>mdi-logout</v-icon> Logout</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-content>
      <v-container fluid>
        <slot></slot>
      </v-container>
    </v-content>
    <!--    <v-footer-->
    <!--            color="indigo"-->
    <!--            app-->
    <!--    >-->
    <!--      <span class="white&#45;&#45;text">&copy; 2019</span>-->
    <!--    </v-footer>-->
  </v-app>
</template>

<script>
export default {
  name: "DefaultLayout",
  data: () => ({
    drawer: null,
    title: ""
  }),
  mounted() {
    // console.log('ROUTE IN DEFAULT', this.$route);
  }
};
</script>

<style>
#rehab-logo {
  max-width: 90%;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 15px;
}

.v-list-item--link.theme--light
  > div.v-list-item__icon.v-list-group__header__append-icon {
  margin-left: 10px;
  min-width: 0;
}
</style>
